import type { LucideIcon } from "lucide-react";

interface CardItem {
  icon?: LucideIcon;
  title: string;
  description: string;
  image?: string;
}

interface CardGridProps {
  items: CardItem[];
  columns?: 2 | 3 | 4;
}

const colsClass = { 2: "md:grid-cols-2", 3: "md:grid-cols-3", 4: "md:grid-cols-2 lg:grid-cols-4" };

const CardGrid = ({ items, columns = 3 }: CardGridProps) => {
  return (
    <div className={`grid grid-cols-1 ${colsClass[columns]} gap-8 md:gap-10`}>
      {items.map((item) => (
        <div key={item.title} className="bg-card border border-border p-7 md:p-9">
          {item.image && (
            <div className="aspect-[16/10] overflow-hidden mb-6 -mx-7 -mt-7 md:-mx-9 md:-mt-9">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover" loading="lazy" />
            </div>
          )}
          {item.icon && <item.icon className="w-7 h-7 text-accent mb-5" strokeWidth={1.5} />}
          <h3 className="font-headline text-xl md:text-2xl text-foreground mb-3">{item.title}</h3>
          <p className="text-muted-foreground text-base leading-relaxed">{item.description}</p>
        </div>
      ))}
    </div>
  );
};

export default CardGrid;
